import * as ko from "knockout";
import {_} from 'lodash';
import {nsUtils} from "./nsUtils";
import {TBtnHeader} from ".";
import btn_headerHtml from './btn-header.html?raw';

export const template = btn_headerHtml

export class viewModel {
    constructor(private btn: TBtnHeader) {
    }

    private getButtonBindings(): any {
        const enable = nsUtils.isNullOrUndefined(this.btn.enabled)
            ? true
            : _.isFunction(this.btn.enabled)
                ? ko.pureComputed(() => this.btn.enabled())
                : this.btn.enabled;

        return _.defaultsDeep({
            title: this.btn.label,
            enable: enable,
            click: this.btn.onClick,
            cls: this.btn.cls,
        }, this.btn)
    }
}